// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Scope_Enum;
(function (Scope_Enum) {
    Scope_Enum["ORG"] = "ORG";
    Scope_Enum["USER"] = "USER";
    Scope_Enum["LOCATION"] = "LOCATION";
    Scope_Enum["LOCATION_USER"] = "LOCATION_USER";
    Scope_Enum["ASSET"] = "ASSET";
    Scope_Enum["ASSET_USER"] = "ASSET_USER";
    Scope_Enum["ASSET_LOCATION"] = "ASSET_LOCATION";
    Scope_Enum["ASSET_LOCATION_USER"] = "ASSET_LOCATION_USER";
})(Scope_Enum || (Scope_Enum = {}));
export var Scope_Enum_index;
(function (Scope_Enum_index) {
    Scope_Enum_index[Scope_Enum_index["ORG"] = 0] = "ORG";
    Scope_Enum_index[Scope_Enum_index["USER"] = 1] = "USER";
    Scope_Enum_index[Scope_Enum_index["LOCATION"] = 2] = "LOCATION";
    Scope_Enum_index[Scope_Enum_index["LOCATION_USER"] = 3] = "LOCATION_USER";
    Scope_Enum_index[Scope_Enum_index["ASSET"] = 4] = "ASSET";
    Scope_Enum_index[Scope_Enum_index["ASSET_USER"] = 5] = "ASSET_USER";
    Scope_Enum_index[Scope_Enum_index["ASSET_LOCATION"] = 6] = "ASSET_LOCATION";
    Scope_Enum_index[Scope_Enum_index["ASSET_LOCATION_USER"] = 7] = "ASSET_LOCATION_USER";
})(Scope_Enum_index || (Scope_Enum_index = {}));
/**
 * Add an enum value for every setting type added to the oneof below.
 * For ease of understanding keep index values in sync with the oneof below.
 */
export var SettingType_Enum;
(function (SettingType_Enum) {
    SettingType_Enum["INVALID"] = "INVALID";
    SettingType_Enum["TEST_SETTING"] = "TEST_SETTING";
    SettingType_Enum["TEST_NO_DEFAULT_SETTING"] = "TEST_NO_DEFAULT_SETTING";
    SettingType_Enum["AUTO_MESSAGING_LOCATION_SETTING"] = "AUTO_MESSAGING_LOCATION_SETTING";
    SettingType_Enum["INBOX_LOCATION_SETTING"] = "INBOX_LOCATION_SETTING";
    SettingType_Enum["INBOX_LOCATION_USER_SETTING"] = "INBOX_LOCATION_USER_SETTING";
    SettingType_Enum["INBOX_USER_SETTING"] = "INBOX_USER_SETTING";
})(SettingType_Enum || (SettingType_Enum = {}));
export var SettingType_Enum_index;
(function (SettingType_Enum_index) {
    SettingType_Enum_index[SettingType_Enum_index["INVALID"] = 0] = "INVALID";
    SettingType_Enum_index[SettingType_Enum_index["TEST_SETTING"] = 1] = "TEST_SETTING";
    SettingType_Enum_index[SettingType_Enum_index["TEST_NO_DEFAULT_SETTING"] = 2] = "TEST_NO_DEFAULT_SETTING";
    SettingType_Enum_index[SettingType_Enum_index["AUTO_MESSAGING_LOCATION_SETTING"] = 3] = "AUTO_MESSAGING_LOCATION_SETTING";
    SettingType_Enum_index[SettingType_Enum_index["INBOX_LOCATION_SETTING"] = 4] = "INBOX_LOCATION_SETTING";
    SettingType_Enum_index[SettingType_Enum_index["INBOX_LOCATION_USER_SETTING"] = 5] = "INBOX_LOCATION_USER_SETTING";
    SettingType_Enum_index[SettingType_Enum_index["INBOX_USER_SETTING"] = 6] = "INBOX_USER_SETTING";
})(SettingType_Enum_index || (SettingType_Enum_index = {}));
